define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"dojo/dom",
	"dojo/dom-attr",
	"dojo/dom-class",
	"dojo/hash",
	"dojo/io-query",
	"dojo/on",
	"dijit/registry",
	"underscore",
	"csi",
	"csi/html",
	"csi/locale",
	"csi/message",
	"csi/sessionActions",
	"csi/comm/PostRequest",
	"csi/widget/FormDeclaration",
	"dijit/form/_TextBoxMixin" // dijit.selectInputText
], function(declare, lang, dom, domAttr, domClass, hash, ioQuery, on, registry, _, csi, html, locale, message, sessionActions, PostRequest, FormDeclaration) {

	var ERROR_MESSAGE_STYLE = "errorMsg";
	var INFO_MESSAGE_STYLE = "infoMsg";
	var NO_MESSAGE_STYLE = "noMsg";
	var ALL_MESSAGE_STYLES = [ERROR_MESSAGE_STYLE, INFO_MESSAGE_STYLE, NO_MESSAGE_STYLE];

	var PASSWORD_ID = "Password";
	var PASSWORD_CONFIRM_ID = "PasswordConfirm";
	var CURRENT_PASSWORD_ID = "CurrentPassword";

	var EXPIRED = "expired";
	var FORGOT_PASSWORD = "forgotPassword";
	var NEW_PASSWORD = "newPassword";

	var LOGIN_BUTTON_LABEL = "loginButton_label";

	function showPageContent() {
		html.setVisibility(html.pageContent(), true);
	}

	return declare(FormDeclaration, {
		// DOMNode
		msgContainerNode: null,
		msgIconNode: null,
		messageNode: null,
		resetPasswordMessage: null,
		resetTokenButton: null,
		loginButton: null,
		backbutton: null,
		loginId: null,

		// boolean
		forgotPassword: false,

		// object
		formValues: null,

		//string
		state: null,

		startup: function() {
			// summary: initial setup of form, and query for authentication providers
			window.document.title = locale.resource("ResetPasswordTitle") + " - " + csi.productName();

			domClass.add(this.msgContainerNode, NO_MESSAGE_STYLE);

			this.messageNode = registry.byId("messageNode");
			this.resetPasswordMessage = dom.byId("resetPasswordMessage");
			this.formValues = ioQuery.queryToObject(this._getQueryString());
			this.state = this.formValues["state"];
			this.loginId = this.formValues["LoginId"];
			this.backButton = registry.byId("backButton");

			if (this.formValues["u"] && this.formValues["token"]) {
				this.state = FORGOT_PASSWORD;
				html.setVisible(this.backButton, false);
				this._checkToken();

				if (this.formValues["u"].indexOf("Administrator") >= 0) {
					this.messageNode.set("value", locale.resource("Change_Admin_Password_Warning"));

					//This text needs to be bolded
					this.messageNode.valueNode.insertAdjacentHTML("afterbegin", locale.resource("Before_Change_Admin_Password_Warning"));
				}

			} else if (this.state && this.state == EXPIRED) {
				html.setVisible(dom.byId("PasswordDiv"), false);
				html.setVisible(dom.byId("PasswordConfirmDiv"), false);
				html.setVisible(this.resetPasswordMessage, true);
				this.setLoginButtonLabel("SendPasswordResetEmail");
				domAttr.set(this.resetPasswordMessage, "textContent", locale.resource("PasswordExpired"));

				showPageContent();
			} else {
				// no token or u, redirect to home page
				document.location.replace(csi.url("home.html") + "#" + hash());
			}
		},

		_checkToken: function() {
			new PostRequest("DataSource", "CheckToken", this.formValues).post({
				load: lang.hitch(this, this._onTokenSuccess),
				error: lang.hitch(this, this._onError),
				timeout: 60000
			});
		},

		_onTokenSuccess: function(response) {
			if (response.getReturnValue() === true) {
				showPageContent();
			} else {
				message.errorDialog({
					message: locale.resource("ResetPasswordLinkExpired"),
					onResponse: function() {
						document.location.replace(csi.url("home.html") + "#" + hash());
					}
				});
			}
		},

		/**
		 * this retrieves the query string without the '?'
		 * @return {String} the query string
		 */
		_getQueryString: function() {
			return document.location.search.substr((document.location.search[0] === "?" ? 1 : 0));
		},

		_onClickField: function( /*Function*/ callback, /*Event*/ event) {
			try {
				callback(event);
			} catch (ex) {
				this._refresh(ex.message, ERROR_MESSAGE_STYLE);
			}
		},

		onSubmit: function( /*Event*/ e) {
			// summary: send passwords over to verify and change user password
			// reset message states
			domClass.replace(this.msgContainerNode, NO_MESSAGE_STYLE, ALL_MESSAGE_STYLES);

			this._refresh(locale.resource("LoginStatus"), INFO_MESSAGE_STYLE, true);

			if (!this._verifyPasswords()) {
				e.preventDefault();
				return;
			}
			var postRequest = null;
			if (this.state && this.state == EXPIRED) {
				postRequest = new PostRequest("SiteAdmin", "SendPasswordResetEmail", {
					username: this.loginId,
					manualSet: false
				});
			} else {
				this._addFormValues();
				postRequest = new PostRequest("DataSource", "TokenLoginAndChangePassword", this.formValues);
			}

			try {
				postRequest.post({
					load: lang.hitch(this, this._onLoad),
					error: lang.hitch(this, this._onError),
					timeout: 60000
				});
			} catch (e) {
				this._refresh(e.message, ERROR_MESSAGE_STYLE);
			}


			e.preventDefault();
		},

		/**
		 * this function validates that the passwords entered are the same and are valid
		 * @returns {boolean} returns true if the passwords match and pass all validation; false if the passwords are not valid
		 */
		_verifyPasswords: function() {
			var password = dom.byId(PASSWORD_ID).value;
			var passwordConfirm = dom.byId(PASSWORD_CONFIRM_ID).value;

			if (password !== passwordConfirm) {
				this._onError({"message": locale.resource("PasswordsMustMatch")});
				return false;
			}

			return true;
		},

		_addFormValues: function() {
			this.formValues[PASSWORD_ID] = dom.byId(PASSWORD_ID).value;
		},

		_getFormValues: function() {
			var formValues = {};
			_.each(this.getFormFields(), function(node) {
				if (node && node.id)
					formValues[node.id] = node.value;
			});
			return formValues;
		},

		_onLoad: function(response) {
			// summary: set the user locale to the localStorage/cookie and redirect to the home page
			var session = response.getResultNode();
			if (session) {
				var localeName = session.UserLocale;
				if (localeName) {
					locale.storeLocale(localeName);
				}
			}
			document.location.replace(csi.url("home.html") + "#" + hash());
		},

		_onInitError: function(err) {
			html.setDisabled(this.loginButton, true);
			this._showError(err, true);
		},

		_onError: function(err) {
			if (err.csiErrorCode == "SRV_ERR_SiteAdmin_TOO_MANY_FAILED_ATTEMPTS") {
				// need to send the user back to the login page if they exceeded the max number of failed login attempts
				alert(err.message);
				sessionActions.logoutAction();
			} else if (err.csiErrorCode == "SRV_ERR_Identity_TOKEN_TIME_LIMIT_EXPIRED") {
				// redirect user to login page if the password reset token is expired on form submit
				message.errorDialog({
					message: locale.resource("ResetPasswordTokenExpired"),
					onResponse: function() {
						document.location.replace(csi.url("home.html") + "#" + hash());
					}
				});
			} else {
				this._showError(err, false);
			}
		},

		_showError: function(err, bDisabled) {
			// summary: show error message in login form - any unhandled exceptions encountered during login are treated as if server is unresponsive
			// to make errors during system startup consistent to the user
			var msg = err.message;

			if (err.csiErrorCode == "SRV_ERR_SiteAdmin_UNHANDLED_EXCEPTION") {
				msg = locale.resource("SERVER_UNRESPONSIVE");
			} else if (err.csiErrorCode == "SRV_ERR_SiteAdmin_PASSWORD_RESET_ERROR") {
				msg = locale.resource("UserInactive");
			}

			this._refresh(msg, ERROR_MESSAGE_STYLE, bDisabled);
			showPageContent();
		},

		_refresh: function(/*String*/message, /*String?*/msgStyle, /*Boolean*/bDisabled) {
			// summary: display submit message
			domClass.replace(this.msgContainerNode, msgStyle || NO_MESSAGE_STYLE, ALL_MESSAGE_STYLES);

			if (message) {
				this.messageNode.set("icon", msgStyle == INFO_MESSAGE_STYLE ? this.messageNode.REFRESH : this.messageNode.ERROR);
				this.messageNode.set("value", message);
			}

			_.each(this.getFormFields(), function(node) {
				html.setDisabled(node, bDisabled);
			});
		},

		getFormFields: function() {
			return {"Password": dom.byId(PASSWORD_ID), "PasswordConfirm": dom.byId(PASSWORD_CONFIRM_ID)};
		},

		/**
		* Set the button label based on the view
		* @param {string} label - the button label
		*/
		setLoginButtonLabel: function(label) {
			domAttr.set(LOGIN_BUTTON_LABEL, "textContent", locale.resource(label));
		}

	});

});